<script>
export default {
  name: 'ChaileaseContractPrint1',
  props: {
    item: Object,
  }
};
</script>

<template>
  <div class="wrapper" v-if="item">
    <div class="page page1">
      <div class="div1">
        <table>
          <tr>
            <td width="230" height="33"></td>
            <td>{{ item.customer.memberId }}</td>
          </tr>
          <tr>
            <td colspan="2" height="28">{{ item.customer.home.residencePost }}{{ item.customer.home.residenceCity }}{{ item.customer.home.residenceArea }}{{ item.customer.home.residenceAddress }}</td>
          </tr>
          <tr>
            <td width="230" height="60"></td>
            <td>{{ item.customer.memberId }}</td>
          </tr>
        </table>
        <table>
          <tr>
            <td width="120" height="28">{{item.laonhfcInfo.carId}}</td>
            <td width="180">{{ item.laonhfcInfo.vendor }}</td>
            <td>{{ item.laonhfcInfo.name }}</td>
          </tr>
        </table>
        <table>
          <tr>
            <td width="30" height="42"> </td>
            <td>{{ item.laonhfcInfo.manufactureDate }}</td>
          </tr>
        </table>
      </div><!--/.div1-->
      <div class="div2">
        <table>
          <tr>
            <td width="90"> </td>
            <td width="290">{{ item.customer.memberId }}</td>
            <td>{{ item.customer.memberId }}</td>
          </tr>
        </table>
      </div><!--/.div2-->
    </div><!--/.page-->
  </div><!--/.wrapper-->
</template>

<style scoped>
html,
body {
  height: 100%;
}

body {

}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.page {
  position: relative;
  width: 210mm;
  height: 297mm;
  margin: 0mm auto;
  border: 1px #D3D3D3 solid;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  font-family: Arial, "黑體-繁", "微軟正黑體", "Microsoft JhengHei", "新細明體", Helvetica, sans-serif;
  color: #0505da !important;
}

/* .page1 {
  background-image: url(images/中租掃描文件-付款買賣契約.jpg);
  background-size: cover;
} */

@media print {
  .page {
    margin: 0;
    border: initial;
    border-radius: initial;
    box-shadow: initial;
    page-break-after: always;
  }

  .page1 {
    background-image: none;
    background-size: none;
  }
}

.wrapper {
  position: relative;
  margin: 0 auto;
  width: 100%;
  background: #fff;
  font-family: Arial, "黑體-繁", "微軟正黑體", "Microsoft JhengHei", "新細明體", Helvetica, sans-serif;
  font-size: 12px;
  padding: 0;
  margin: 0;
  font-size: 14px !important;;
  color: #0505da !important;
  font-weight: bold;
}

table {
  width: 100%;
  margin: 0;
}

table td {
  padding: 0;
}

/*區塊*/
.div1 {
  position: absolute;
  top: 20.2mm;
  left: 32mm;
  width: 100%;
}

.div2 {
  position: absolute;
  bottom: 55.5mm;
  left: 18mm;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ChaileaseContractPrint1.vue